import { computed } from '@vue/composition-api';
import { DataTableHeader } from 'vuetify';

import { useMessages } from '@/base/app';

import { GroupCourseProgresses } from '../../../domains';
import { formatRate, sortByNumber } from '../../utils/TableUtils';

export type UserUsageTraineeProgressItem = GroupCourseProgresses;

export type PropsUserUsageTraineeProgressTable = {
  users: UserUsageTraineeProgressItem[];
};

const HEADERS: DataTableHeader[] = [
  { value: 'userName', text: '', class: 'base-table-name' },
  { value: 'notBegunContentCount', text: '', align: 'center', width: 100 },
  { value: 'inProgressContentCount', text: '', align: 'center', width: 100 },
  { value: 'completedContentCount', text: '', align: 'center', width: 100 },
  { value: 'progressRate', text: '', align: 'center', width: 100, sort: sortByNumber },
];

export function useUserUsageTraineeProgressTable(props: PropsUserUsageTraineeProgressTable) {
  const msgs = useMessages({ prefix: 'report.molecules.userUsageTraineeProgressTable' });

  const headers = HEADERS.map((header) => ({
    ...header,
    text: msgs.of(header.value).value,
  }));

  const items = computed(() => {
    return props.users
      .map((c) => ({
        ...c,
        progressRate: formatRate(c.progressRate),
      }))
      .sort((a, b) => {
        if (a.userName === b.userName) return a.userId < b.userId ? -1 : 1;
        return a.userName < b.userName ? -1 : 1;
      });
  });

  return {
    headers,
    items,
  };
}

export type UserUsageTraineeProgressTable = ReturnType<typeof useUserUsageTraineeProgressTable>;
